import { CommonModule } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';

@Component({
    selector: 'base-modal',
    standalone: true,
    imports: [CommonModule, ModalModule],
    templateUrl: './modal.component.html',
})
export class ModalComponent implements AfterViewInit {
    ngAfterViewInit(): void {
        const modalRef = document.querySelector('.modal');
        modalRef?.classList.add('app-modal');
        modalRef?.classList.add('in');
    }
}
